module.exports = __webpack_public_path__ + "static/media/success.9eebcc30.svg";